module.exports = __webpack_public_path__ + "img/ceyiceOne.f69bfc3b.png";